// White-label brand config — see WHITELABEL.md.
export const BRAND = {
  name: 'Vogue Nails',
  shortName: "Vogue",
  legalName: 'Vogue Nails',
  tagline: "Manalapan's Home For Beautiful Nails",
  vertical: 'other' as 'cleaning' | 'barbershop' | 'other',

  phone: '(732) 536-2100',
  phoneHref: 'tel:7325362100',
  email: 'book@voguenails.com',
  domain: 'vogue-nails-manalapan.pages.dev',

  logo: '/images/logo.svg',

  serviceArea: "Manalapan, NJ",

  trust: {
    bondedInsured: false,
    satisfactionGuarantee: true,
    yearsInBusiness: null as number | null,
    ecoFriendly: false,
  },

  social: {
    facebook: '',
    instagram: '',
    google: '',
  },

  bookingNoun: 'appointment',
  workerNoun: 'nail tech',
};

export default BRAND;
